import { all, call, takeLatest, put } from 'redux-saga/effects'
import { request } from 'utils/request'
import { loginFormComponentActions } from '.'
import { loadAndSetUserDataSaga } from '../../ApplicationManagementComponent/slice/saga'

export function* loginUserSaga(actions) {
  const { values, successCb } = actions.payload
  const requestURL = `${process.env.GATSBY_DIRECTUS}/auth/login`

  try {
    const timestamp = Math.floor(Date.now() / 1000)
    const response = yield call(request, requestURL, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(values)
    })

    // Set auth.
    yield put(
      loginFormComponentActions.setAuth({
        accessToken: response.data.access_token,
        expires: response.data.expires,
        refreshToken: response.data.refresh_token,
        timestamp: timestamp
      })
    )

    // First load user data.
    yield call(loadAndSetUserDataSaga)

    yield all([put(loginFormComponentActions.setIsLoading(false)), successCb()])
  } catch (e: any) {
    if (e.response.status === 401) {
      yield put(
        loginFormComponentActions.setLoginFormAsyncError(
          '__LOGIN_CREDENTIALS_WRONG__'
        )
      )
      yield put(loginFormComponentActions.setIsLoading(false))
    } else {
      console.error(e)
    }
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* loginFormComponentSaga() {
  // Watches for loadRepos actions and calls getRepos when one comes in.
  // By using `takeLatest` only the result of the latest API call is applied.
  // It returns task descriptor (just like fork) so we can continue execution
  // It will be cancelled automatically on component unmount
  yield takeLatest(loginFormComponentActions.setLogin.type, loginUserSaga)
}
